import { IProductListData, OrderEntity } from '@/types';
import { IBrandData } from '@/types/brand';
import { makeAutoObservable } from 'mobx';

interface IStoreGlobal {
  data?: IProductListData;
  currentProductId: string;
  editMode: boolean;
  order?: OrderEntity;
  currentComponentId: string;
  // hicustom 面列表里最后选中的 compId，关掉 ComponentScene 后仍保留高亮
  hicustomSelectedCompId: string;
  // hicustom Design All 模式：打开一个不绑定具体 face 的主画布，Done 时把设计层同步到所有 view
  hicustomDesignAll: boolean;
  tool: string;
  brandData?: IBrandData;
  colorPrimary: string;
  iframeMode: boolean;
}

export function createStoreGlobal() {
  return makeAutoObservable<IStoreGlobal>({
    data: undefined,
    currentProductId: '',
    editMode: true,
    order: undefined,
    currentComponentId: '',
    hicustomSelectedCompId: '',
    hicustomDesignAll: false,
    tool: '',
    brandData: undefined,
    colorPrimary: '#5792c9',
    iframeMode: false,
  });
}

export type TStoreGlobal = ReturnType<typeof createStoreGlobal>;
